/**
 * Extract a list from a httpService response. httpService wraps successful
 * responses as { value }, but on error returns { error: "..." }. We need to
 * tolerate both shapes and always end up with an array (empty if not present).
 */
export const unwrapList = (res) => {
  const inner = res?.value ?? res?.data ?? res;
  return Array.isArray(inner) ? inner : [];
};

/**
 * Extract a single object from a httpService response. Returns null if the
 * response was an error.
 */
export const unwrapObject = (res) => {
  if (!res) return null;
  if (res.error) return null;
  return res.value ?? res.data ?? res;
};
